// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./common/image.res.js");
var Utils$ReactHooksTemplate = require("./common/utils.res.js");

function PasswordReset(props) {
  var urlParams = Belt_List.fromArray(Js_string.split("&", props.url));
  var arr = Belt_List.getBy(urlParams, (function (x) {
          return Js_string.includes("reset_password_token=", x);
        }));
  var token;
  if (arr !== undefined) {
    var match = Js_string.split("=", arr);
    token = match.length !== 2 ? undefined : match[1];
  } else {
    token = undefined;
  }
  var reset_password_token = token !== undefined ? token : "";
  var match$1 = React.useState(function (param) {
        return "";
      });
  var setPassword = match$1[1];
  var password = match$1[0];
  var match$2 = React.useState(function (param) {
        return "";
      });
  var setConfirm = match$2[1];
  var confirm = match$2[0];
  var match$3 = React.useState(function (param) {
        return false;
      });
  var setShowPassword = match$3[1];
  var showPassword = match$3[0];
  var match$4 = React.useState(function (param) {
        return false;
      });
  var setShowConfirm = match$4[1];
  var showConfirm = match$4[0];
  var lengthValid = password.length >= 8;
  var capitalValid = /[A-Z]/.test(password);
  var alphabetValid = /[A-Za-z]/.test(password);
  var numberValid = /[0-9]/.test(password);
  var specialValid = /[!@#$%^&*(),.?\":{}|<>]/.test(password);
  var matchValid = password !== "" && confirm !== "" && password === confirm;
  var allValid = lengthValid && alphabetValid && numberValid && specialValid && matchValid && capitalValid;
  var passType = showPassword ? "text" : "password";
  var confirmType = showConfirm ? "text" : "password";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("form", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "Password",
                                            className: "float-left text-darkcharcoal text-sm font-medium mb-1",
                                            htmlFor: "pass"
                                          }),
                                      JsxRuntime.jsx("input", {
                                            name: "authenticity_token",
                                            type: "hidden",
                                            value: Utils$ReactHooksTemplate.csrfToken
                                          }),
                                      JsxRuntime.jsx("input", {
                                            name: "account[reset_password_token]",
                                            type: "hidden",
                                            value: reset_password_token
                                          }),
                                      JsxRuntime.jsx("input", {
                                            className: "rounded-lg bg-white w-full h-40-px text-sm font-normal pl-4 pr-10 py-3 focus:border focus:border-black",
                                            id: "pass",
                                            name: "account[password]",
                                            type: passType,
                                            value: password,
                                            onChange: (function (e) {
                                                Curry._1(setPassword, (function (param) {
                                                        return e.target.value;
                                                      }));
                                              })
                                          }),
                                      JsxRuntime.jsx("button", {
                                            children: JsxRuntime.jsx("img", {
                                                  className: "w-4 h-4 mt-1",
                                                  src: showPassword ? Image$ReactHooksTemplate.closedEye : Image$ReactHooksTemplate.previewEye
                                                }),
                                            className: "absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 text-xs flex items-center",
                                            type: "button",
                                            onClick: (function (param) {
                                                Curry._1(setShowPassword, (function (prev) {
                                                        return !prev;
                                                      }));
                                              })
                                          })
                                    ],
                                    className: "relative"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "Re-enter password",
                                            className: "float-left text-darkcharcoal text-sm font-medium mb-1",
                                            htmlFor: "confirm"
                                          }),
                                      JsxRuntime.jsx("input", {
                                            className: "rounded-lg bg-white w-full h-40-px text-sm font-normal pl-4 pr-10 py-3 focus:border focus:border-black",
                                            id: "confirm",
                                            name: "account[password_confirmation]",
                                            type: confirmType,
                                            value: confirm,
                                            onChange: (function (e) {
                                                Curry._1(setConfirm, (function (param) {
                                                        return e.target.value;
                                                      }));
                                              })
                                          }),
                                      JsxRuntime.jsx("button", {
                                            children: JsxRuntime.jsx("img", {
                                                  className: "w-4 h-4 mt-1",
                                                  src: showConfirm ? Image$ReactHooksTemplate.closedEye : Image$ReactHooksTemplate.previewEye
                                                }),
                                            className: "absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 text-xs flex items-center",
                                            type: "button",
                                            onClick: (function (param) {
                                                Curry._1(setShowConfirm, (function (prev) {
                                                        return !prev;
                                                      }));
                                              })
                                          })
                                    ],
                                    className: "relative"
                                  })
                            ],
                            className: "text-center flex flex-col gap-8 w-1/2 max-w-390-px"
                          }),
                      !lengthValid || !alphabetValid || !numberValid || !specialValid || !capitalValid ? JsxRuntime.jsx("p", {
                              children: "Password does not meet all requirements.",
                              className: "text-red-500 text-sm"
                            }) : null,
                      confirm !== "" && !matchValid ? JsxRuntime.jsx("p", {
                              children: "Passwords do not match.",
                              className: "text-red-500 text-sm"
                            }) : null,
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: "Password must include",
                                    className: "text-darksilver text-sm font-normal"
                                  }),
                              JsxRuntime.jsxs("ul", {
                                    children: [
                                      JsxRuntime.jsxs("li", {
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    src: lengthValid ? Image$ReactHooksTemplate.greenTick : Image$ReactHooksTemplate.errorInfoIcon
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "at least 8 characters"
                                                  })
                                            ],
                                            className: "flex items-center space-x-3"
                                          }),
                                      JsxRuntime.jsxs("li", {
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    src: capitalValid ? Image$ReactHooksTemplate.greenTick : Image$ReactHooksTemplate.errorInfoIcon
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "at least 1 uppercase alphabet"
                                                  })
                                            ],
                                            className: "flex items-center space-x-3"
                                          }),
                                      JsxRuntime.jsxs("li", {
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    src: alphabetValid ? Image$ReactHooksTemplate.greenTick : Image$ReactHooksTemplate.errorInfoIcon
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "at least 1 alphabet"
                                                  })
                                            ],
                                            className: "flex items-center space-x-3"
                                          }),
                                      JsxRuntime.jsxs("li", {
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    src: numberValid ? Image$ReactHooksTemplate.greenTick : Image$ReactHooksTemplate.errorInfoIcon
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "a number"
                                                  })
                                            ],
                                            className: "flex items-center space-x-3"
                                          }),
                                      JsxRuntime.jsxs("li", {
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    src: specialValid ? Image$ReactHooksTemplate.greenTick : Image$ReactHooksTemplate.errorInfoIcon
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "a special character"
                                                  })
                                            ],
                                            className: "flex items-center space-x-3"
                                          }),
                                      JsxRuntime.jsxs("li", {
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    src: matchValid ? Image$ReactHooksTemplate.greenTick : Image$ReactHooksTemplate.errorInfoIcon
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "password confirmation should be same"
                                                  })
                                            ],
                                            className: "flex items-center space-x-3"
                                          })
                                    ],
                                    className: "space-y-3"
                                  })
                            ],
                            className: "flex flex-col gap-6 w-1/2 max-w-390-px"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("input", {
                                  className: allValid ? "py-10-px px-30-px rounded-lg w-full bg-black text-ufogreen cursor-pointer" : "py-10-px px-30-px rounded-lg w-full bg-black text-ufogreen opacity-50 cursor-not-allowed",
                                  disabled: !allValid,
                                  type: "submit",
                                  value: "Save and Continue"
                                }),
                            className: "flex items-center w-1/2 max-w-390-px"
                          })
                    ],
                    className: "w-full flex flex-col items-center gap-4",
                    action: "/accounts/password/update",
                    method: "post"
                  })
            });
}

var make = PasswordReset;

exports.make = make;
/* react Not a pure module */
